module.exports = __webpack_public_path__ + "img/default_img.ab66a174.jpg";